import { render, staticRenderFns } from "./EmailRichArgument.vue?vue&type=template&id=42f46e36&"
import script from "./EmailRichArgument.vue?vue&type=script&lang=js&"
export * from "./EmailRichArgument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports